module.exports = __webpack_public_path__ + "static/wish-background-bf98980efe1f05802c80351fcec454bd.jpeg";